import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import '../../css/teacher_list.css';
import ApiService from '../../../../services/api';
import  Add from '../../../../media/add.png';
import  Edit from '../../../../media/edit.png';
import  Edit2 from '../../../../media/edit_dark.png';
import  Delete from '../../../../media/delete.png';
import  Course from '../../../../media/courses_white.png';
import Search from '../../../../media/search.png';
import { confirmToast } from '../../../app/components/confirmToast';
import AdminSelect from './admin_select';


const CourseList = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  const DEFAULT_VISIBILITY_OPTION = {
    value: null,
    label: "Filtra per disponibilità"
  };

  const DEFAULT_HIGHLIGHTED_OPTION = {
    value: null,
    label: "Filtra per evidenza"
  };

  const [selectedVisibility, setSelectedVisibility] = useState(
    DEFAULT_VISIBILITY_OPTION
  );

  const [selectedHighlighted, setSelectedHighlighted] = useState(
    DEFAULT_HIGHLIGHTED_OPTION
  );

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const res = await ApiService.getCourses();
        setCourses(res);
      } catch (err) {
        console.error('Errore nel recupero corsi:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

   const normalizedSearch = search.trim().toLowerCase();

  
  const visibilityOptions = [
    DEFAULT_VISIBILITY_OPTION,
    {
      value: true,
      label: "Disponibili"
    },
    {
      value: false,
      label: "Non disponibili"
    }
  ];

  const highlightedOptions = [
    DEFAULT_HIGHLIGHTED_OPTION,
    {
      value: true,
      label: "In evidenza"
    },
    {
      value: false,
      label: "Non in evidenza"
    }
  ];

  const filteredCourses = courses.filter(c => {
    const courseTitle = `${c.title}`.toLowerCase();

    const matchesSearch =
      courseTitle.includes(normalizedSearch);

    const matchesVisibility =
      selectedVisibility.value === null ||
      c.visibility === selectedVisibility.value;

    const matchesHighlighted =
      selectedHighlighted.value === null ||
      c.highlighted === selectedHighlighted.value;

    return (
      matchesSearch &&
      matchesVisibility &&
      matchesHighlighted
    );
  });

  const handleDelete = async (slug) => {
    confirmToast({
                message: "Sei sicuro di voler eliminare questo corso?",
                type: "error",
                confirmText: "Elimina",
                 onConfirm: async () => {
                  try {
                    ApiService.deleteCourse(slug);
                    setCourses(prev => prev.filter(c => c.slug !== slug));
                    toast.success("Corso eliminato con successo");
                  } catch (err) {
                    toast.error("Errore durante l'eliminazione del corso");
                          
                  }
                },
              });
  };

  return (
    <div className="teacher-list-container">
      <div className="teacher-list-header" style={{marginBottom:'50px'}}>
        <h2><img src={Course} alt="" className="section-image" />Corsi</h2>
        <div className='search-zone'>
          <img src={Search} alt="Cerca" className="search-image" />
          <input
          className='search-area'
          type="text"
          placeholder="Cerca corso..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <button className="create-button" onClick={() =>  navigate('crea')}>
          <img src={Add} alt="Aggiungi" className="button-image" />
        </button>
      </div>

      <div
        style={{
          display: "flex",
          gap: "15px",
          marginBottom: "30px",
          flexWrap: "wrap"
        }}
      >
        <AdminSelect
          options={visibilityOptions}
          value={selectedVisibility}
          onChange={setSelectedVisibility}
          isSearchable={false}
          width="250px"
        />

        <AdminSelect
          options={highlightedOptions}
          value={selectedHighlighted}
          onChange={setSelectedHighlighted}
          isSearchable={false}
          width="250px"
        />
      </div>

      {loading ? (
        <p>Caricamento...</p>
      ) : courses.length === 0 ? (
        <p>Nessun corso disponibile.</p>
      ) : (
        <ul className="teacher-list">
          {filteredCourses.map((course) => (
            <li key={course.id} className="teacher-card">
              <img
                src={course.main_img}
                alt={course.title}
                className="teacher-avatar"
              />
              <div className="teacher-info">
                <strong>{course.title}</strong>
              </div>
              <div className="teacher-actions">
                <button
                className='create-button3'
                  style={{marginRight:'60px'}}
                  onClick={() => navigate(`/admin/moduli/gestisci/${course.slug}`, {
                      state: { courseTitle: course.title , courseSlug: course.slug  },
                    })}
                  type='button'
                >
                  <img src={Edit2} alt="Modifica" className="button-image" style={{marginTop:'-2.5px', marginRight:'2.5px'}}/>
                  Gestisci moduli
                </button>
                <button
                  className="create-button"
                  onClick={() => navigate(`modifica/${course.slug}`)}
                >
                  <img src={Edit} alt="Modifica" className="button-image" />
                </button>
                <button
                  className="create-button"
                  onClick={() => handleDelete(course.slug)}
                >
                  <img src={Delete} alt="Elimina" className="button-image" />
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CourseList;
